export const getApiUrl = (): string => {
    const isStaging = process.env.REACT_APP_ENV === 'staging';

    if (isStaging) {
        const localStorageApiUrl = localStorage.getItem('apiUrl');
        if (localStorageApiUrl) {
            return localStorageApiUrl;
        }
    }

    return process.env.REACT_APP_API_URL as string;
};

export const config = {
    apiUrl: getApiUrl(),
    socketUrl: process.env.REACT_APP_SOCKET_URL as string,
    proxiedApiUrl: (process.env.REACT_APP_PROXIED_API_URL ??
        process.env.REACT_APP_API_URL) as string,
    storage: {
        previousRoute: 'previousRoute',
        cookieConfig:
            window.location.hostname === '.iqos.ro' ||
            window.location.hostname === 'localhost' ||
            window.location.hostname === '127.0.0.1'
                ? ';path=/'
                : `;secure;path=/`,
        googleMapsKey: process.env.REACT_APP_GOOGLE_MAPS_KEY as string,
        marketingOptIn: process.env.REACT_APP_MARKETING_OPT_IN as string,
        gtmId: 'GTM-PLBRD26',
        appId: '1401488693436528',
        turnstileKey: process.env.REACT_APP_TURNSTILE_KEY as string,
        oldPoints: 'oldPoints',
        getStream: {
            apiKey: process.env.REACT_APP_GETSTREAM_API_KEY as string,
            appId: process.env.REACT_APP_GETSTREAM_APP_ID as string,
            feedGroup: 'timeline',
            feedGroupSticky: 'sticky',
            userId: 'global'
        },
        licenseKey: process.env.REACT_APP_LICENSE_KEY as string,
        scrollHorizontallyKey: process.env.REACT_APP_SCROLL_HORIZONTALL_KEY as string,
        fadingEffectKey: process.env.REACT_APP_FADING_EFFECT_KEY as string,
        slackKey: process.env.REACT_APP_SLACK_HOOK as string,

        //Entry UserName call for dreams
        entryUserName: 'entryUserName'
    },
    user: {
        authTokenRecommend: 'authTokenRecommend',
        authToken: 'authToken',
        authTokenExpiresAt: 'authTokenExpiresAt',
        refreshToken: 'refreshToken',
        refreshTokenExpiresAt: 'refreshTokenExpiresAt',
        autoRefreshToken: 'autoRefreshToken',
        profileHasEligibleDevice: 'profileHasEligibleDevice',
        profileActivatedAt: 'profileActivatedAt',
        termsAndConditions: 'termsAndConditions',
        userId: 'userId',
        isPWA: 'isPWA',
        isAdult: 'isAdult',
        user: 'user',
        getstreamFeedToken: 'getstreamFeedToken',
        appVersion: 'appVersion',
        completed_tutorial: 0,
        tutorial_session: 0,
        selectedIqosAnswersSeason: 'selectedIqosAnswersSeason',
        insertedCodes: 'insertedCodes',
        storyMuted: 'storyMuted',
        postListBenefts: 'postListBenefts',
        flavourBanModalLastShow: 'flavourBanModalLastShow',
        tradeInModal: 'tradeInModal',
        hasVeevDevice: 'hasVeevDevice',
        tasteExplorationLastShow: 'tasteExplorationLastShow',
        realConnectionsModalShow: 'realConnectionsModalShow',
        tenYearsTheme: 'tenYearTheme',
        tereaPrelaunchTheme: 'tereaPrelaunchTheme',
        steveAokiDeviceTheme: 'steveAokiDeviceTheme',
        celebratoryTakeoverHasAutostarted: 'celebratoryTakeoverHasAutostarted',
        celebratoryTakeoverOpen: 'celebratoryTakeoverOpen',
        dailyGame: 'dailyGame',
        aokiTakeoverHasAutostarted: 'aokiTakeoverHasAutostarted',
        p5EnrollCookie: 'enrolled-in-p5',
        storageUUID: 'storageUUID',
        cookieUUID: 'cookieUUID'
    },
    path: {
        index: '/',
        notFound: '/404',
        contact: '/contact',
        regulation: {
            index: '/regulament',
            promotion: '/regulament/promotie/:promotion_id'
        },

        FAQs: '/intrebari-frecvente',
        howItWorks: '/cum-functioneaza',
        notifications: '/notificari',
        termsAndConditions: '/termeni-si-conditii',
        termsConditionsTradeIn: '/termeni-si-conditii-trade-in',
        termsConditionsUGC: '/termeni-si-conditii-ugc',
        cookiesPolicy: '/politica-cookies',
        map: '/harta',
        locations: '/locatii-iqos',
        listWinners: '/lista-castigatori',
        discoverIQOS: '/descopera-iqos',
        error: '/eroare',
        iqos: {
            index: 'https://www.iqos.ro/',
            iqosOn: 'https://www.iqos.ro/auto-delivery-landing-page',
            map: 'https://www.iqos.ro/store/ro/search',
            shop: 'https://www.iqos.ro/iqos3-duo/heets-iqos-3',
            register: 'https://www.iqos.ro/profiles-add',
            forgotPassword: 'https://www.iqos.ro/auth-loginform?loyalty=1',
            latestNew: 'https://www.iqos.ro/noutati',
            tutorial: 'https://www.iqos.ro/asistenta/',
            warranty: 'https://www.iqos.ro/garantie-iqos',
            termsConditions: 'https://www.iqos.ro/conditii-de-utilizare',
            termsConditionsTradeIn: 'https://www.iqos.ro/termeni-si-conditii-trade-in',
            privacy: 'https://www.iqos.ro/privacy',
            dataProtection: 'https://www.iqos.ro/privacy-business-partners',
            cookiesPolicy: 'https://www.iqos.ro/cookies',
            termsConditionsUGC: 'https://www.iqos.ro/continut-generat-de-utilizatori',
            heetsCollection: 'https://www.iqos.ro/iqos3-duo/heets-iqos-3?login_overlay=1',
            autoDelivery: 'https://www.iqos-on.ro/product/autodelivery',
            capsCollection:
                'https://www.iqos.ro/iqos-originals-duo/accesorii-iqos-originals/duo-personalizare/capacele-colorate-iqos-duo',
            iqosContact: 'https://www.iqos.ro/contact-iqos',
            iqosContacteaza: 'https://www.iqos.ro/contacteaza-iqos',
            ilumaPrime: 'https://www.iqos.ro/iluma-prime',
            iluma: 'https://www.iqos.ro/iluma',
            discoverIluma: 'https://www.iqos.ro/despre-iqos/descopera-iluma',
            shopList: 'https://win.heatnotburn.ro/ListaMagazine',
            tradeIn: 'https://www.iqos.ro/trade-in',
            tradeInAbout: 'https://www.iqos.ro/myiqos/asistenta/programul-iqos-trade-in-schimb',
            regulation: 'https://www.iqos.ro/club/regulament?sectiunea=4'
        },
        socialMedia: {
            facebook: 'https://www.facebook.com/iqos.ro',
            twitter: 'https://twitter.com/iqos_support_ro',
            instagram: 'https://www.instagram.com/iqos_ro',
            youtube: 'https://www.youtube.com/channel/UCO3xTgEvUw7iwwvL-s81s0w'
        },
        teasing: '/teasing',
        regulament:
            'https://storage.gft-dev.ro/media/customUpload/2025/6/909315/2025-06-06-RR-JS---50000-premii-si-experiente.pdf',
        revendicaPremiu: '/revendica-premiu',
        revendica: '/revendica',
        revendicaInvitatia: '/revendica-invitatia',
        listaCastigatori: '/lista-castigatori',
        carouselPremii: '/premii',
        gondola: '/gondola',
        listaLocatiilor: '/lista-locatiilor'
    }
};

export const validationMessages = {
    required: 'Acest câmp este obligatoriu.',
    types: {
        email: 'Adresa de email nu este validă.',

        phone: 'Numărul de telefon nu este valid.',
        phone_only_numbers: 'Numărul de telefon trebuie să conțină doar cifre',
        phone_max_characters: 'Numărul de telefon trebuie să conțină cel mult 10 cifre',

        letters_only: 'Câmpul trebuie să conțină doar litere'
    }
};
